export enum CourseStatusEnum {
  All = 'all',
  Published = 'Published',
  Draft = 'Draft',
  In_Progress = 'In Progress'
}
